// @TODO: support for blob and file?
var encodingMap = {
  formData: 'multipart/form-data; charset=UTF-8',
  formEncoded: 'application/x-www-form-urlencoded; charset=UTF-8',
  json: 'application/json; charset=UTF-8'
}

var version = (function() {
  var meta = document.getElementById('cupidmedia-release')
  return meta && meta.content
})()

var isRelease = function(req) {
  var release = req.getResponseHeader('x-cupidmedia-release')
  if (release !== null && release !== version) {
    window.location.assign(req.responseURL)
    return true
  }
  return false
}

// XMLHttpRequest load handler
function onload(req, resolve, reject) {
  var status = req.status
  var location =
    req.getResponseHeader('Location') ||
    (function() {
      return /redirectLink/.test(req.response)
        ? ((status = 302), JSON.parse(req.response).redirectLink)
        : ''
    })()

  if (isRelease(req)) return

  // Check if an autologin response has been returned
  // When an API call is done with no session a HTTP 302 response is returned instead of JSON
  // Chrome automatically redirects and returns the CORS response (an HTML page with the autologin rendered).
  // This is done as API calls expect JSON not an HTML page
  // This loosely looks for the the autologin in the response and then treats the response as such.
  if ( /auth\/(autologin|login)/.test(req.responseURL) && status == 200) {
    status = 302
    location = window.location
  }

  // XHR processes the 302 to the login form transparently in cases where
  // the user has unchecked "rememberme".
  // We test response for the form name and redirect to the original URL
  // if found.

  if (/loginSubmitForm/.test(req.response)) {
    status = 302
    location = req.url
  }

  if (status == 200) {
    resolve(req.response)
  }
  else if (status == 302) {
    window.location.href = location
  } else {
    reject(new Error('CM:Server returned error ' + status + ': ' + req.statusText))
  }
}

var get = function(url, options) {
  return new Promise(function(resolve, reject) {
    var req = new XMLHttpRequest()
    req.url = url
    req.open('GET', url)
    req.withCredentials = true
    req.format = options.format || 'html'
    req.setRequestHeader(
      'Accept',
      'application/vnd.cupidmedia.' + (options.format || 'html') + ', image/*'
    )
    if (options.additionalResourceFlags) {
      req.setRequestHeader('cupidmedia-flags', options.additionalResourceFlags)
    }

    if (options.onloadstartHandler) {
      req.onloadstart = options.onloadstartHandler
    }

    if (options.onprogressHandler) {
      //req.addEventListener("progress",  options.onprogressHandler);
      req.onprogress = options.onprogressHandler
    }

    req.send()

    req.onload = function() {
      onload(req, resolve, reject)
    }

    req.onerror = function(err) {
      reject(err)
    }
  })
}

var post = function(url, data, encoding, format) {
  return new Promise(function(resolve, reject) {
    var req = new XMLHttpRequest()
    req.url = url
    req.open('POST', url)
    req.withCredentials = true
    req.setRequestHeader(
      'Accept',
      'application/vnd.cupidmedia.' + (format || 'html') + ', image/*'
    )
    if(encoding != 'noEncode'){
      req.setRequestHeader('Content-Type', encodingMap[encoding || 'formEncoded'])
    }
    req.send(data)

    req.onload = function() {
      onload(req, resolve, reject)
    }

    req.onerror = function(err) {
      reject(err)
    }
  })
}

module.exports = {
  get: get,
  post: post,
  isRelease: isRelease
}
